import { BaseEntityPage } from '../../components/common';
import { MajorsContent } from './components';

export default function MajorsPage() {
	return (
		<BaseEntityPage ContentComponent={MajorsContent} />
	);
}